export const environment = {
  production: false,
  host: 'https://backoffice.aprendity.com',
  apiUrl: 'https://backoffice.aprendity.com/api/node',
  apiKey: 'my-dev-api-key',
  recaptcha:{
    siteKey: '6Lce11EoAAAAACAwyDiHsqUiSFgI5cQ-5AaW8010',
  }
};
